<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    max-width="300px"
  >
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12 sm6>
                <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
                <v-spacer></v-spacer>
            </v-flex>
            <v-flex xs12 sm6>
                <v-text-field
                v-model="password"
                :type="'password'"
                label="Password"
                value="wqfasds"
                hint="At least 6 characters"
                :rules="[rules.required]"
                ></v-text-field>

            </v-flex>
            <v-flex xs12 sm6>
                <v-spacer></v-spacer>
            </v-flex>
            <v-flex xs12 sm12 v-if="message">
                <p class="red--text">{{message}}</p>
                <v-spacer></v-spacer>
            </v-flex>
            
            <v-flex xs12 sm6>
                <v-btn
                :disabled="!valid"
                color="success"
                @click="login"
                >
                Submit
                </v-btn>
            </v-flex>

        </v-layout>
    </v-container>
  </v-form>
</template>

<script>
    // TODO: validation not needed

    // import db from '@/fb'
    import firebase from 'firebase/app'
    require('firebase/auth')
    export default {
        data: () => ({
        valid: true,
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        password: null,
        rules: {
            required: value => !!value || 'Required.'
        },
        select: null,
        message: null
        }),

    methods: {
        login(){
            if(this.email && this.password){
                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(cred => {
                    console.log(cred.user)
                    this.$router.push({name: 'dashboard'})
                })
                .catch(err => {
                    this.feedback = err.message
                })
                this.feedback = null
            } else {
                this.feedback="please enter both fields"
            }
        }
    }
  }
</script>
